// Convert a date value to the `datetime-local` input format: YYYY-MM-DDTHH:MM
export function toDateTimeLocal(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";

  const pad = (n) => String(n).padStart(2, "0");
  const year = d.getFullYear();
  const month = pad(d.getMonth() + 1);
  const day = pad(d.getDate());
  const hours = pad(d.getHours());
  const minutes = pad(d.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

// Convert a date value to the `date` input format: YYYY-MM-DD
export function toDateLocal(value) {
  if (!value) return "";

  // If it's a string that already contains a YYYY-MM-DD prefix, return that
  if (typeof value === "string") {
    const m = value.match(/^(\d{4}-\d{2}-\d{2})/);
    if (m) return m[1];
  }

  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  const year = d.getFullYear();
  const month = pad(d.getMonth() + 1);
  const day = pad(d.getDate());
  return `${year}-${month}-${day}`;
}

// Parse a date or date-time value and return a local timestamp set to a fixed hour.
// - If `value` is a YYYY-MM-DD string, the local date at `hour` is returned.
// - If `value` is an ISO string with time or timezone, the UTC date components are used
//   so that a UTC-midnight value preserves the same calendar day when shown locally.
export function parseToLocalFixedHour(value, hour = 19) {
  if (!value) return null;

  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split("-").map((n) => parseInt(n, 10));
    return new Date(y, m - 1, d, hour, 0, 0).getTime();
  }

  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return null;

  if (typeof value === "string" && /T|Z/.test(value)) {
    const y = dt.getUTCFullYear();
    const mo = dt.getUTCMonth();
    const d = dt.getUTCDate();
    return new Date(y, mo, d, hour, 0, 0).getTime();
  }

  return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), hour, 0, 0).getTime();
}

export default toDateTimeLocal;
